import { Actions as ResourceActions } from "./actions";

const initialState = {
  allResources: [],
};

const resourceReducer = (state = initialState, action) => {
  switch (action.type) {
    case ResourceActions.SET_RESOURCES:
      return { ...state, allResources: action.value };
    default:
      return state;
  }
};

export default resourceReducer;
